export default __webpack_public_path__ + "static/media/Drone-2.90b34ea2.jpg";